import { createContext, useContext, useMemo, useState } from 'react';
import { DEFAULT_FORECAST } from '../constants/forecast';

const ForecastContext = createContext(null);

const cloneDefaultForecast = () =>
    JSON.parse(JSON.stringify(DEFAULT_FORECAST));

export function ForecastProvider({ children }) {
    const [forecast, setForecast] = useState(() => cloneDefaultForecast());
    const [forecastTable, setForecastTable] = useState(() => []);
    const [forecastRequestKey, setForecastRequestKey] = useState('');
    const [generalDemographic, setGeneralDemographic] = useState(false);

    const resetForecast = () => {
        setForecast(cloneDefaultForecast());
        setForecastTable([]);
        setForecastRequestKey('');
        setGeneralDemographic(false);
    };

    const value = useMemo(
        () => ({
            forecast,
            setForecast,
            forecastTable,
            setForecastTable,
            forecastRequestKey,
            setForecastRequestKey,
            generalDemographic,
            setGeneralDemographic,
            resetForecast,
        }),
        [forecast, forecastTable, forecastRequestKey, generalDemographic]
    );

    return (
        <ForecastContext.Provider value={value}>
            {children}
        </ForecastContext.Provider>
    );
}

export const useForecast = () => {
    const context = useContext(ForecastContext);
    if (!context) {
        throw new Error('useForecast must be used within a ForecastProvider');
    }
    return context;
};
